import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import PasswordInput from '../atoms/PasswordInput';
import { formatWhatsapp } from '../utils/phone';

function RegisterForm({ onSubmit, loading, error }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [localError, setLocalError] = useState(null);

  function handleWhatsappChange(e) {
    setWhatsappNumber(formatWhatsapp(e.target.value));
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (password !== confirmPassword) {
      setLocalError('As senhas não coincidem.');
      return;
    }
    setLocalError(null);
    onSubmit({ name, email, whatsappNumber, password });
  }

  // Só depois de a confirmação começar a ser digitada: avisar da diferença já
  // no primeiro caractere marcaria de vermelho um campo que ainda está sendo
  // preenchido.
  const mismatch = confirmPassword.length > 0 && password !== confirmPassword;

  return (
    <>
      {(error || localError) && (
        <Alert variant="danger" className="small py-2 mb-3 text-center" style={{ borderRadius: 12 }}>
          {error || localError}
        </Alert>
      )}

      <Form onSubmit={handleSubmit}>
        <Form.Control
          type="text"
          placeholder="Nome do estabelecimento"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          autoComplete="organization"
          autoCapitalize="words"
          autoCorrect="off"
          enterKeyHint="next"
          className="mb-3 auth-input"
        />
        <Form.Control
          type="email"
          placeholder="E-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
          inputMode="email"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck="false"
          enterKeyHint="next"
          className="mb-3 auth-input"
        />
        <Form.Control
          type="tel"
          placeholder="WhatsApp (com DDD)"
          value={whatsappNumber}
          onChange={handleWhatsappChange}
          required
          autoComplete="tel-national"
          inputMode="numeric"
          enterKeyHint="next"
          className="mb-3 auth-input"
        />
        <PasswordInput
          placeholder="Senha (mín. 8 caracteres)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={8}
          autoComplete="new-password"
          enterKeyHint="next"
          className="mb-3"
        />
        <PasswordInput
          placeholder="Confirmar senha"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          minLength={8}
          autoComplete="new-password"
          enterKeyHint="done"
          isInvalid={mismatch}
          className="mb-2"
        />
        {/* Antes, senhas diferentes só apareciam depois de tocar em "Criar
            conta", e como um alerta no topo — longe do campo que causou. */}
        <p className="auth-field-error mb-3" role={mismatch ? 'alert' : undefined}>
          {mismatch ? 'As senhas não coincidem.' : ''}
        </p>

        <button type="submit" disabled={loading} className="auth-submit">
          {loading ? 'Criando conta…' : 'Criar conta'}
        </button>
      </Form>
    </>
  );
}

export default RegisterForm;
